import { formatStringWithPrecision } from "./stringUtils";

const transformNumberToOneDecimalPlace = (value) => {
    // if it isn't a number
    if (isNaN(value) || value === null) return value;

    // if it does not have a decimal with two or more numbers
    if (!value.toString().match(/\.\d{2,}/)) return value;

    return Number(formatStringWithPrecision(value, 1, true));
};

const transformStringToUpCase = (value) => {
    // if it isn't populated
    if (value === null) return value;

    return value.toUpperCase();
};

export {
    transformNumberToOneDecimalPlace,
    transformStringToUpCase
};


